import {
  ContactDetail,
  ContactDetailProps,
} from './contact-detail/ContactDetail';
import './Contact.scss';
import { Map } from '../components/map/Map';
import contactInfo from '../contact-info.json';
import {
  faFacebookF,
  faInstagram,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function Contact() {
  return (
    <section id="contact" className="contact">
      <div className="contact-details">
        {contactDetails.map((detail, index) => (
          <ContactDetail
            icon={detail.icon}
            name={detail.name}
            content={detail.content}
            key={index}
          />
        ))}
      </div>
      <Map />
    </section>
  );
}

const contactDetails: ContactDetailProps[] = [
  {
    name: 'Téléphone',
    icon: 'fa-solid fa-phone',
    content: [
      { content: contactInfo.phone, linkTo: `tel:${contactInfo.phone}` },
    ],
  },
  {
    name: 'Email',
    icon: 'fa-solid fa-envelope',
    content: [
      { content: contactInfo.email, linkTo: `mailto:${contactInfo.email}` },
    ],
  },
  {
    name: 'Adresse',
    icon: 'fa-solid fa-map-marker-alt',
    content: [
      {
        content: contactInfo.address,
        linkTo: `https://www.google.com/maps/search/?api=1&query=${contactInfo.address.replace(' ', '+')}`,
      },
    ],
  },
  {
    name: 'Réseaux sociaux',
    icon: 'fa-brands fa-instagram',
    content: [
      {
        content: <FontAwesomeIcon icon={faInstagram as IconProp} />,
        linkTo: contactInfo.instagram,
      },
      {
        content: <FontAwesomeIcon icon={faFacebookF as IconProp} />,
        linkTo: contactInfo.facebook,
      },
      {
        content: <FontAwesomeIcon icon={faLinkedin as IconProp} />,
        linkTo: contactInfo.linkedin,
      },
    ],
  },
];
